
import React, { Component } from 'react';

import DWTEditBar from './DWTEditBar.js';
import DWTScan from './DWTScan.js';
import DWTUploadAndSave from './DWTUploadAndSave.js';
import OutputMessage from './OutputMessage.js';
import { DwtUIOperations } from './tools/dwtUIOperations';
const containerId = 'dwtcontrolContainer';
const dwtUtil = new DwtUIOperations(containerId);

export default class Dwt extends Component {

  componentDidMount() {
    dwtUtil.onPageInit(window);
  }

  componentWillUnmount() {
    dwtUtil.destroy();
  }

  render() {
    return (
      <>
      
        <div className="ds-dwt-content ds-dwt-center">
          <div id="DWTcontainerTop">
            <DWTEditBar dwtUtil={dwtUtil} ></DWTEditBar>
            <div id={containerId} ></div>
          </div>
          <div id="ScanWrapper">
            <DWTScan dwtUtil={dwtUtil}></DWTScan>
            <DWTUploadAndSave dwtUtil={dwtUtil} fileUploadFunction={this.props.fileUploadFunction}></DWTUploadAndSave>
            {/* <OutputMessage></OutputMessage> */}
          </div>
        </div>
      </>
    );
  }
}
